import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import clientKey from './client-storage'

const vuexPersist = new VuexPersist({
  key: clientKey,
  storage: window.localStorage
})

Vue.use(Vuex)

const initialState = {
  ticketData: null,
  clientSelected: {},
  groupSelected: null,
  branchSelected: null,
  serviceSelected: null,
  viewSelected: 'Services',
  services: [],
  groupsServices: {},
  groups: {},
  groupsInfo: [],
  branches: [],
  hourSelected: null,
  hours: [],
  availability: true,
  kioskSettings: [],
  skipHourSelection: false,
  skipCustomerDataForm: false,
  serviceGroupSegmentationData: {},
  currentCollectedInfo: {
    treeLevels: [],
    thirdPartyServices: [],
    segmentationData: {
      userSegmentationSata: '',
      userSegmentationSataType: '',
      userSegmentationSataTypeCode: '',
    },
    thirdPartyAppointments: [],
    printThirdPartyAppointments: false,
    thirdPartyAppointmentSelected: {
      id: 0,
      date: ''
    },
    userData: {
      first_name: '',
      last_name: '',
      user_priority_level: 0,
      user_priority_level_original: null,
      wsName: ''
    },
    recipe_list: [],
    branchFlow: false,
    userPhone: null, 
    userName: null,
  },
  generalError: false,
  dayAvailableSelected:[],
  appointment_range: 0,
  customerKey: "",
  segmentationToken: {},
  segmentationDatas: {},
  segmentationDataGroups: [],
  groupIdSelected: 0,
  segmentationType: {},
  generalMessage: {
    modal: false,
    text: "",
    groupOrServiceSelected: null,
  },
  generalMessageTicket: {
    show: false,
    text: ""
  },
  headerData: {},
  minDay: "",
  branchFlow: false,
  userDataNoAuth: {
    fullName: null,
    cellphone: null,
    reCaptchaCode: null
  },
  ticketType: '',
  settings: {},
  policyAccepted: true,
  routeName: "",
  socket: {
    isConnected: false,
    message: '',
    reconnectError: false,
  }
}

export default new Vuex.Store({
  state: {
    ...initialState
  },
  mutations: {
    RESET_STATE(state) {
      for (let prop in state) {
        state[prop] = initialState[prop]
      }
    },
    resetSegmentationNoAuth(state) {
      state.customerKey = ""
      state.segmentationToken = {}
      state.segmentationDatas = {}
      state.segmentationType = {}
    },
    setGroupSelected(state, groupSelected){
      state.groupSelected = groupSelected
    },
    setServiceGroupSegmentationData(state, serviceGroupSegmentationData){
      state.serviceGroupSegmentationData = serviceGroupSegmentationData
    },
    setKioskSettings(state, kioskSettings){
      state.kioskSettings = kioskSettings
    },
    setAvailability(state, availability){
      state.availability = availability
    },
    setBranchSelected(state, branchSelected){
      state.branchSelected = branchSelected
    },
    setViewSelected(state, viewSelected){
      state.viewSelected = viewSelected
    },
    setServiceSelected(state, serviceSelected){
      state.serviceSelected = serviceSelected
    },
    setHourSelected(state, hourSelected){
      state.hourSelected = hourSelected
    },
    setClientSelected(state, clientSelected){
      state.clientSelected = clientSelected
    },
    setBranches(state, branches){
      state.branches = branches
    },
    setHours(state, hours){
      state.hours = hours
    },
    setServices(state, services){
      state.services = services
    },
    setGroupsServices(state, groupsServices){
      state.groupsServices = groupsServices
    },
    setGroups(state, groups){
      state.groups = groups
    },
    setTicketData(state, ticketData){
      state.ticketData = ticketData
    },
    setGroupsInfo(state, groupsInfo){
      state.groupsInfo = groupsInfo
    },
    setSkipHourSelection(state, skipHourSelection) {
      state.skipHourSelection = skipHourSelection
    },
    setSkipCustomerDataForm(state, skipCustomerDataForm) {
      state.skipCustomerDataForm = skipCustomerDataForm
    },
    setTreeLevels(state, treeLevels) {
      state.currentCollectedInfo.treeLevels = treeLevels
    },
    setThirdPartyServices(state, thirdPartyServices) {
      state.currentCollectedInfo.thirdPartyServices = thirdPartyServices
    },
    setSegmentationData(state, segmentationData) {
      state.currentCollectedInfo.segmentationData = segmentationData
    },
    setThirdPartyAppointments(state, thirdPartyAppointments) {
      state.currentCollectedInfo.thirdPartyAppointments = thirdPartyAppointments
    },
    setPrintThirdPartyAppointments(state, printThirdPartyAppointments) {
      state.currentCollectedInfo.printThirdPartyAppointments = printThirdPartyAppointments
    },
    setThirdPartyAppointmentSelected(state, thirdPartyAppointmentSelected) {
      state.currentCollectedInfo.thirdPartyAppointmentSelected = thirdPartyAppointmentSelected
    },
    resetCurrentCollectedInfo(state) {
      state.currentCollectedInfo = {
        treeLevels: [],
        thirdPartyServices: [],
        segmentationData: {
          userSegmentationData: '',
					userSegmentationDataType: ''
        },
        thirdPartyAppointments: [],
        printThirdPartyAppointments: false,
        thirdPartyAppointmentSelected: {
          id: 0,
          date: ''
        },
        userData: {
          first_name: '',
          last_name: '',
          user_priority_level: 0,
          user_priority_level_original: null,
          wsName: ''
        },
        recipe_list: [],
        userName: null,
        userPhone: null
      }
      state.ticketType = ''
    },
    setGeneralError(state, generalError) {
      state.generalError = generalError
    },
    setGeneralMessage(state, generalMessage) {
      state.generalMessage = generalMessage
    },
    setGeneralMessageTicket(state, generalMessageTicket) {
      state.generalMessageTicket = generalMessageTicket
    },
    setUserNameData(state, userData) {
      console.log(userData)
      state.currentCollectedInfo.userData = userData
    },
    setRecipeList(state, recipeList) {
      state.currentCollectedInfo.recipe_list = recipeList
    },
    setDayAvailableSelected(state, dayAvailableSelected){
      state.dayAvailableSelected = dayAvailableSelected
    },
    setAppointment_range(state, appointment_range){
      state.appointment_range = appointment_range
	  },
    setSegmentationToken(state, segmentationToken){
      state.segmentationToken = segmentationToken
    },
    setSegmentationDatas(state, segmentationDatas){
      state.segmentationDatas = segmentationDatas
    },
    setCustomerKey(state, customerKey){
      state.customerKey = customerKey
    },
    setSegmentationDataGroups(state, segmentationDataGroups){
      state.segmentationDataGroups = segmentationDataGroups
    },
    setGroupIdSelected(state, groupIdSelected){
      state.groupIdSelected = groupIdSelected
    },
    setSegmentationType(state, segmentationType){
      state.segmentationType = segmentationType
    },
    setHeaderData(state, headerData){
      state.headerData = headerData
    },
    setMinDay(state, minDay){
      state.minDay = minDay
    },
    setUserDataNoAuth(state, userDataNoAuth){
      state.userDataNoAuth = userDataNoAuth
    },
    setBranchFlow(state, branchFlow){
      state.branchFlow = branchFlow
    },
    setUserName(state, userName) {
      state.currentCollectedInfo.userName = userName
    },
    setUserPhone(state, userPhone) {
      state.currentCollectedInfo.userPhone = userPhone
    },
    setTicketType(state, ticketType) {
      state.ticketType = ticketType
    },
    setSettings(state, settings){
      state.settings = settings
    },
    setPolicyAccepted(state, policyAccepted){
      state.policyAccepted = policyAccepted
    },
    setRouteName(state, routeName){
      state.routeName = routeName
    },
    SOCKET_ONOPEN(state, event) {
      state.socket.isConnected = true
    },
    SOCKET_ONCLOSE(state, event) {
        state.socket.isConnected = false
    },
    SOCKET_ONERROR(state, event) {
        console.error(state, event)
    },
    SOCKET_ONMESSAGE(state, message) {
        state.socket.message = message
    },
    SOCKET_RECONNECT(state, count) {
        console.info(state, count)
    },
    SOCKET_RECONNECT_ERROR(state) {
        state.socket.reconnectError = true;
    }
  },
  actions: {
    resetSegmentationNoAuth({commit}) {
      commit('resetSegmentationNoAuth')
    },
    groupSelect({commit}, groupSelected){
      commit('setGroupSelected', groupSelected)
    },
    changeKioskSettings({commit}, kioskSettings){
      commit('setKioskSettings', kioskSettings)
    },
    updateServiceGroupSegmentationData({commit}, serviceGroupSegmentationData){
      commit('setServiceGroupSegmentationData', serviceGroupSegmentationData)
    },
    changeAvailability({commit}, availability){
      commit('setAvailability', availability)
    },
    branchSelect({commit}, branchSelected){
      commit('setBranchSelected', branchSelected)
    },
    viewSelect({commit}, viewSelected){
      commit('setViewSelected', viewSelected)
    },
    serviceSelect({commit}, serviceSelected){
      commit('setServiceSelected', serviceSelected)
    },
    hourSelect({commit}, hourSelected){
      commit('setHourSelected', hourSelected)
    },
    clientSelect({commit}, clientSelected){
      commit('setClientSelected', clientSelected)
    },
    setArrayBranches({commit}, branches){
      commit('setBranches', branches)
    },
    setArrayHours({commit}, hours){
      commit('setHours', hours)
    },
    setArrayServices({commit}, services){
      commit('setServices', services)
    },
    setArrayGroupsServices({commit}, groupsServices){
      commit('setGroupsServices', groupsServices)
    },
    setObjGroups({commit}, groups){
      commit('setGroups', groups)
    },
    setObjTicketData({commit}, ticketData){
      commit('setTicketData', ticketData)
    },
    setArrGroupsInfo({commit}, groupsInfo){
      commit('setGroupsInfo', groupsInfo)
    },
    setSkipHourSelection({commit}, skipHourSelection) {
      commit('setSkipHourSelection', skipHourSelection)
    },
    setSkipCustomerDataForm({commit}, skipCustomerDataForm) {
      commit('setSkipCustomerDataForm', skipCustomerDataForm)
    },
    setTreeLevels({commit}, treeLevels) {
      commit('setTreeLevels', treeLevels)
    },
    setThirdPartyServices({commit}, thirdPartyServices) {
      commit('setThirdPartyServices', thirdPartyServices)
    },
    setSegmentationData({commit}, segmentationData) {
      commit('setSegmentationData', segmentationData)
    },
    setThirdPartyAppointments({commit}, thirdPartyAppointments) {
      commit('setThirdPartyAppointments', thirdPartyAppointments)
    },
    setPrintThirdPartyAppointments({commit}, printThirdPartyAppointments) {
      commit('setPrintThirdPartyAppointments', printThirdPartyAppointments)
    },
    setThirdPartyAppointmentSelected({commit}, thirdPartyAppointmentSelected) {
      commit('setThirdPartyAppointmentSelected', thirdPartyAppointmentSelected)
    },
    resetCurrentCollectedInfo({commit}) {
      commit('resetCurrentCollectedInfo')
    },
    setThirdPartyServices({commit}, thirdPartyServices) {
      commit('setThirdPartyServices', thirdPartyServices)
    },
    setSegmentationData({commit}, segmentationData) {
      commit('setSegmentationData', segmentationData)
    },
    setGeneralError({commit}, generalError) {
      commit('setGeneralError', generalError)
    },
    setGeneralMessage({commit}, generalMessage) {
      commit('setGeneralMessage', generalMessage)
    },
    setGeneralMessageTicket({commit}, generalMessageTicket) {
      commit('setGeneralMessageTicket', generalMessageTicket)
    },
    setUserNameData({commit}, userData) {
      commit('setUserNameData', userData)
    },
    setRecipeList({commit}, recipeList) {
      commit('setRecipeList', recipeList)
    },
    setDayAvailableSelected({commit}, dayAvailableSelected){
      commit('setDayAvailableSelected', dayAvailableSelected)
    },
    setAppointment_range({commit}, appointment_range){
      commit('setAppointment_range', appointment_range)
	  },
    setSegmentationToken({commit}, segmentationToken){
      commit('setSegmentationToken', segmentationToken)
    },
    setSegmentationDatas({commit}, segmentationDatas){
      commit('setSegmentationDatas', segmentationDatas)
    },
    setCustomerKey({commit}, customerKey){
      commit('setCustomerKey', customerKey)
    },
    setSegmentationDataGroups({commit}, segmentationDataGroups){
      commit('setSegmentationDataGroups', segmentationDataGroups)
    },
    setGroupIdSelected({commit}, groupIdSelected){
      commit('setGroupIdSelected', groupIdSelected)
    },
    setSegmentationType({commit}, segmentationType){
      commit('setSegmentationType', segmentationType)
    },
    setHeaderData({commit}, headerData){
      commit('setHeaderData', headerData)
	  },
    setMinDay({commit}, minDay){
      commit('setMinDay', minDay)
	  },
    setUserDataNoAuth({commit}, userDataNoAuth){
      commit('setUserDataNoAuth', userDataNoAuth)
    },
    setBranchFlow({commit}, branchFlow){
      commit('setBranchFlow', branchFlow)
    },
    setUserName({commit}, userName) {
      commit('setUserName', userName)
    },
    setUserPhone({commit}, userPhone) {
      commit('setUserPhone', userPhone)
    },
    setTicketType({commit}, ticketType) {
      commit('setTicketType', ticketType)
    },
    setSettings({commit}, settings){
      commit('setSettings', settings)
    },
    setPolicyAccepted({commit}, policyAccepted){
      commit('setPolicyAccepted', policyAccepted)
    },
    setRouteName({commit}, routeName){
      commit('setRouteName', routeName)
    }
  },
  modules: {
  },
  getters: {
  },
  plugins: [vuexPersist.plugin]
})
